import type { NavigateFunction } from 'react-router-dom'
import { formatGqlUserMessage } from '@/common/errors/gql-error-utils'
import type { ObjectTypesService } from '../services/ObjectTypesService'
import { newLocalPropDef, type ITypeFormController, type LocalPropDef } from './TypeFormController'

interface CreateTypeControllerProps {
  spaceId: number
  navigate: NavigateFunction
}

export class CreateTypeController implements ITypeFormController {
  initialCustomProps!: LocalPropDef[]
  initialMetaProps!: LocalPropDef[]

  private spaceId!: number
  private navigateFn!: NavigateFunction

  constructor(private readonly objectTypesService: ObjectTypesService) {}

  init({ spaceId, navigate }: CreateTypeControllerProps): void {
    this.spaceId = spaceId
    this.navigateFn = navigate
    this.initialCustomProps = [newLocalPropDef('tag', 'multi-select')]
    this.initialMetaProps = [
      { id: -10001, name: 'Creation Date', type: 'date' },
      { id: -10002, name: 'Last Modified Date', type: 'date' },
      { id: -10003, name: 'Last Opened Date', type: 'date' },
    ]
  }

  onClose(): void {
    void this.navigateFn(-1)
  }

  async onSubmit(name: string, customProps: LocalPropDef[]): Promise<string | undefined> {
    const { error } = await this.objectTypesService.createType({
      name,
      spaceId: this.spaceId,
      propertyDefInputs: customProps.map((p) => ({ name: p.name, type: p.type })),
    })
    if (error) return formatGqlUserMessage(error.message)
    await this.navigateFn(-1)
  }
}
